<div class="ktbl-spacer-top-bottom"></div>
<div class="ktbl-button-container">
    <div class="ktbl-button-container-left">
        <button (click)="onClickSchnelleinstellungen()"
            class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c" type="button">
            <i class="fas fa-bolt ktbl-icon-vertical-align"></i>
            Schnelleinstellungen

        </button>
    </div>

    <div class="ktbl-button-container-right">
        <input type="file" class="ktbl-file-input" (change)="onFileSelected($event)" accept=".csv, .aks" #fileUpload />
        <button (click)="fileUpload.value = ''; fileUpload.click()"
            class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c" type="button">
            <i class="fas fa-file-import ktbl-icon-vertical-align"></i>
            Winddaten importieren
        </button>

        <button (click)="onClickWinddatenExport()" class="ktbl-button-primaer ktbl-button-width-m ktbl-button-width-m-c"
            type="button">
            <i class="fas fa-file-export ktbl-icon-vertical-align"></i>
            Winddaten exportieren
            <i class="fas fa-info-circle ktbl-icon-info-select"
                matTooltip="Die CSV-Vorlage für den Import finden Sie oben unter „Vorlage-Download“."
                matTooltipClass="tooltip-format" [matTooltipPosition]="tooltipPosition.value">
            </i>
        </button>
    </div>
</div>

<div class="ktbl-spacer-top-bottom"></div>

<table mat-table [dataSource]="dataWindRichtlinienabList" class="ktbl-table-breite-komplett">
    <ng-container *ngFor="let column of displayedColsWindRichtlinienab; let j = index" [matColumnDef]="column">

        <th mat-header-cell *matHeaderCellDef [ngClass]="{
                'ktbl-table-header-base-links': j === 0,
                'ktbl-table-header-base-rechts': j === displayedColsWindRichtlinienab.length - 1,
                'ktbl-table-header-base-neutral': j !== 0 && j !== displayedColsWindRichtlinienab.length - 1,
                'ktbl-table-header-typografie': true,
                'ktbl-windrichtung-transportrichtung-beschreibung-width': column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG',
                'ktbl-windhaeufigkeit-width': column === 'WINDHAEUFIGKEIT',
                'ktbl-zul-geruchstund-girl-width': column === 'ZUL_GERUCHSTUND_GIRL'
              }">
            <ng-container *ngIf="column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG'">
                Wind-/Transportrichtung
            </ng-container>
            <ng-container *ngIf="column === 'WINDHAEUFIGKEIT'">
                Windhäufigkeit in ‰
            </ng-container>
            <ng-container *ngIf="column === 'GEBIETSKATEGORIE'">
                Gebietskategorie
            </ng-container>
            <ng-container *ngIf="column === 'ZUL_GERUCHSTUND_GIRL'">
                Zulässige Geruchsstundenhäufigkeit nach Anhang 7 TA Luft in %
            </ng-container>

        </th>
        <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
                'ktbl-table-content-normal': i % 2 === 0 && !entry.isUeberschrift,
                'ktbl-table-content-invert': i % 2 !== 0 && !entry.isUeberschrift,
                'ktbl-table-content-border': j === 0,                
                'ktbl-table-cell-no-padding-right': column === 'ZUL_GERUCHSTUND_GIRL',
                'ktbl-table-cell-left': column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG'
              }">

            <ng-container *ngIf="column === 'WINDRICHTUNG_TRANSPORTRICHTUNG_BESCHREIBUNG'">
                {{ entry.windrichtung }}°/{{ entry.transportrichtung }}°<ng-container
                    *ngIf="(entry.beschreibung ?? '').trim().length"> ({{ entry.beschreibung }})</ng-container>
            </ng-container>



            <ng-container *ngIf="column === 'WINDHAEUFIGKEIT'">
                <mat-form-field appearance="fill" class="ktbl-input-box">
                    <input matInput required class="ktbl-input-table-cell-left" [formControl]="
                    windhaeufigkeitFormControlList[entry.windrichtung / 10]
                  " />
                    <mat-error *ngIf="windhaeufigkeitFormControlList[entry.windrichtung / 10].invalid">
                        {{ formControlGanzZahlLaeng4NumberWarning }}
                    </mat-error>
                </mat-form-field>

            </ng-container>

            <ng-container *ngIf="column === 'GEBIETSKATEGORIE'">

                <mat-form-field appearance="fill" class="ktbl-input-box">
                    <mat-select required disableRipple class="ktbl-table-cell-left "
                        [formControl]="gebietskategorieFormControlList[entry.windrichtung / 10]"
                        panelClass="ktbl-large-select-panel">
                        <mat-option *ngFor="let entry of localService.globalWSData.value"
                            [value]="entry.idGebietskategorie">
                            {{ entry.gebietskategorie }}

                        </mat-option>
                    </mat-select>

                </mat-form-field>


            </ng-container>

            <ng-container *ngIf="column === 'ZUL_GERUCHSTUND_GIRL'">
                <mat-form-field appearance="fill" class="ktbl-input-box">
                    <input matInput required [formControl]="hgFormControlList[entry.windrichtung / 10]" />
                    <mat-error *ngIf="hgFormControlList[entry.windrichtung / 10].invalid">
                        {{ formControlGanzZahlLaeng2OderKomma1NumberWarning }}

                    </mat-error>

                </mat-form-field>

            </ng-container>

        </td>


        <td mat-footer-cell *matFooterCellDef
            class="ktbl-table-summe-gesamt ktbl-table-column-ueberschrift ktbl-table-cell-left">

            <ng-container *ngIf="j === 0">Gesamt:</ng-container>

            <ng-container *ngIf="column === 'WINDHAEUFIGKEIT'">
                {{ windhaeufigkeitSumme }}
            </ng-container>

        </td>


    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColsWindRichtlinienab"></tr>
    <tr mat-row *matRowDef="
              let row;
              columns: displayedColsWindRichtlinienab
            "></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColsWindRichtlinienab"></tr>
</table>